export { loadFooterData } from './footerService';

export { loadMainPageData } from './allRafflesService.';

export { loadMyTitlesData } from './myTitlesService';
export type { ProcessedPrize, ProcessedRaffle } from './myTitlesService';

export { searchAddressByCep, type AddressServiceResponse } from './addressService';
